import { Routes } from '@angular/router';
import { StepperComponent } from './core/stepper/stepper.component';
import { ErrorComponent } from './core/application/error/error.component';
import { InitComponent } from './core/init/init.component';
import { MobiSubLandingPage } from './core/application/mobi-sub-landing-page/mobi-sub-landing-page';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'init', pathMatch: 'full' },
  { path: 'step', component: StepperComponent },
  { path: 'mobi-sub', component: MobiSubLandingPage },
  {
    path: 'error',
    component: ErrorComponent
  },
  { path: 'init', component: InitComponent },

  { path: '**', redirectTo: '/init', pathMatch: 'full' }
];
